var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"model":_vm.model,"attribute":_vm.attribute,"value-field":"id","label":_vm.label,"options":_vm.options,"display-field":"${item.text}","type":"select2","items":_vm.clientTierOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }